<template>
    <div class="form-field">
        <div class="checkbox-wrapper">
          <label :for="name" class="checkbox-input">
            <div class="checkbox-input__text">
              <span class="label">{{ label }}</span>
              <span class="text" v-if="text">{{ text }}</span>
            </div>
            <input type="checkbox" :name="name" :id="name" v-model="value">
            <span class="checkbox"></span>
          </label>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SingleCheckbox',
  props: {
    notice: '',
    name: '',
    label: '',
    text: '',
    modelValue: {},
  },
  data(){
    return {
      value: this.modelValue,
    };
  },
  watch: {
    value(){
      this.$emit('update:modelValue', this.value);
    }
  }
}
</script>

<style scoped>
  .label {
    margin-bottom: 2px;
    opacity: 1;
  }
  .text {
    opacity: 0.8;
    font-size: 1.2rem;
    font-weight: 300;
    line-height: 1.67;
  }

  .checkbox-input {
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  .checkbox {
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: solid 1px #dadde2;
    background: white;
  }

  .checkbox:after {
    content: '';
		position: absolute;
		width: 10px;
		height: 9px;
		display: block;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 0;
		background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMiAxMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMSA2IDQgNCA2LTkiIHN0cm9rZT0iI0ZBRjhGNCIgc3Ryb2tlLXdpZHRoPSIxLjQiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+");
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center center;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  input:checked + .checkbox {
    background: #da503b;
    border-color: #da503b;
  }
  input:checked + .checkbox:after {
    opacity: 1;
  }
</style>
